const GET_NO_OF_DOORS = 'GET_NO_OF_DOORS';
const SET_NO_OF_DOORS = 'SET_NO_OF_DOORS';

export
{
    GET_NO_OF_DOORS,
    SET_NO_OF_DOORS
};
